const ACTIVE_RUN_KEY = 'pod:bulk-upload-active-run'

export type BulkUploadActiveRun = {
  batchId: string
  documentType: string
  folderKey: string
  totalDocs: number
  processedDocs: number
  startedAt: number
}

export function persistActiveRun(run: BulkUploadActiveRun): void {
  try {
    sessionStorage.setItem(ACTIVE_RUN_KEY, JSON.stringify(run))
  } catch {
    /* ignore */
  }
}

export function loadActiveRun(): BulkUploadActiveRun | null {
  try {
    const raw = sessionStorage.getItem(ACTIVE_RUN_KEY)
    if (!raw) return null
    return JSON.parse(raw) as BulkUploadActiveRun
  } catch {
    return null
  }
}

export function clearActiveRun(): void {
  try {
    sessionStorage.removeItem(ACTIVE_RUN_KEY)
  } catch {
    /* ignore */
  }
}
